<template>
  <div>
  <!-- ヘッダ -->
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>

        <v-container fluid class="container-14">
          <p class="pl-4">お申込み後、管轄法務局への提出までのご案内です。</p>
        
        <!-- データ入力エリア -->
        <v-simple-table class="simple-table">
          <template v-slot:default>
            <tbody v-for="item in desserts" :key="item.num" >
              <tr >
                <td class="table-title" rowspan="4">{{ item.num }}</td>
              </tr>
              <tr>
                <td class="table-td-1">
                  <u>{{ item.title }}</u>
                </td>
              </tr>
              <tr class="simple-table-tr">
                <td class="table-td-3">
                  {{ item.subTitle }}
                </td>
              </tr>
              <tr class="simple-table-tr " height="120" aspect-ratio="1.0" contain>
                <td class="table-td-2">
                  <div v-html="item.info"></div>                    
                </td>
              </tr>
              <br>
            </tbody>
          </template>
        </v-simple-table>
        <v-row style="margin-top: -40px !important;">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px"  @click="back()">ホームへ戻る</v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px" @click="logout()">ログアウトする</v-btn>
          </v-col>
        </v-row>
        </v-container>
      </v-container>
    </v-main>
    <!-- フッター(なし) -->
    <comMessageConfirm :msg="dlgMsgLogoutConfirm.msg" :isOpen="dlgMsgLogoutConfirm.isOpen" :doYes="dlgMsgLogoutConfirm.doYes" :doNo="dlgMsgLogoutConfirm.doNo" />
  </div>
</template>

<script>
import Constants from "../common/constants";
export default {
  name: "InputRequestAfterDescription",
    data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "お申込み後の流れ",
      screenId: "MBR600",
      messageArea: "",
      desserts: [],

      dlgMsgLogoutConfirm: {
        msg: "",
        isOpen: false,
        doYes: () => {
          // 編集状態初期化
          this.clearStoreForLogOutMixin();
          // 次画面遷移
          this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
        },
        doNo: () => {
          this.dlgMsgLogoutConfirm.isOpen = false;
        },
      },
    };
        
  },
  created() {
    this.initialize();
  },
  methods: {
   /*
    * 初期表示
    */
    initialize: function() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbr600.area');
      this.dispSearchData();
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setLoginInfoMixin();
      this.username = authInfo['username'];
      this.companyname = authInfo['companyname'];
    },

   /*
    * ホームへ戻るボタン押下
    */
    back: function() {
        this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
    },

   /*
    * ログアウトボタン押下
    */
    logout: function() {
      // 確認メッセージ表示
        this.dlgMsgLogoutConfirm.msg = this.$i18n.t('msg.wrn.ps010');
        this.dlgMsgLogoutConfirm.isOpen = true;
    },
    /*
    * 申込後の流れ情報取得・表示
    */
    dispSearchData : async function() {
      this.desserts = [];
      // サービス呼び出し
      let apiurl = Constants.URL_API_MBR600G01;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        // 申込済情報表示
        if (this.dispSearchResultData(response.data)) {
          this.dlgMsgErr.msg = response.data.message;
          this.dlgMsgErr.isOpen = true;
        }
      } catch(error) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['お申込み後手順']);
          this.dlgMsgErr.isOpen = true;
      }
      return;
    },
    dispSearchResultData: function(responseDto) {
      let hasErr = true;
      let contentList = responseDto.data
      if (contentList == null) {
        return hasErr;
      }
      hasErr = false;
      let contentArry = {};
      let contentCount = 0;
      for (let content of contentList) {
        contentArry = {};
        contentCount += 1;
        contentArry['num'] = contentCount;
        contentArry['title'] = content.title;
        contentArry['subTitle'] = content.subTitle;
        contentArry['info'] = content.content;
        this.desserts.push(contentArry);
      }
      return hasErr;
    },
  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
}
.simple-table-tr:hover {
  background: transparent !important;
}
.table-title {
  text-align: center;
  background-color: #E2F0D8;
  width: 5%;
  font-size: 1.5em !important;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black !important;
}
.table-td-1 {
  text-align: left;
  padding: 6px 6px !important;
  font-size: 1.2em !important;
  background-color: #E2F0D8;
  color: #548235;
  border-top: 1px solid black;
  border-right: 1px solid black;
  border-left: 1px solid black;
}
.table-td-2 {
  text-align: left;
  padding: 6px 6px !important;
  border-right: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black !important;
  outline: none;
}
.table-td-3 {
  text-align: left;
  padding: 6px 6px !important;
  font-size: 0.8em !important;
  color: #000000;
  border-top: none;
  border-right: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid white !important;
  outline: none;
}

</style>

